{
  "fr": {
    "locale_field": {
      "fallback_tooltip": "Lorsqu'aucun texte n'est saisi pour cette langue, ce texte par défaut sera utilisé comme solution de repli.",
      "fill_missing": "Remplir la langue manquante ({count}) | Remplir les langues manquantes ({count})",
      "fill_missing_budget_used": "Le budget IA de ce mois est épuisé.",
      "fill_missing_done": "Langues manquantes remplies. Vérifiez le texte avant d'enregistrer.",
      "fill_missing_errors": {
        "budget_reached": "Le budget IA de ce mois est épuisé. Contactez Ziggu pour l'augmenter.",
        "generic": "Les langues n'ont pas pu être remplies. Veuillez réessayer.",
        "too_long": "Ce texte est trop long pour être traduit en une fois."
      },
      "fill_missing_tooltip": "Traduit depuis {language} avec l'IA. Vérifiez le texte avant d'enregistrer.",
      "translated_in": "Traduit en"
    }
  }
}
